import * as React from 'react';

interface IPerformanceInfoProps {
    performanceDateString: string;
    performanceTimeString: string;
    filterDateAndTimeTitle: string;
    changeDateAndButtonText: string;

    onChangeDateClick?: () => any;
    showComponent: boolean;
    hideDateChange: boolean;
}

class PerformanceInfo extends React.PureComponent<IPerformanceInfoProps, any>{
    constructor(props) {
        super(props);
    }

    render() {
        var button = null;
        if (!this.props.hideDateChange) {
            button = <button className="filters-section-heading-btn"
                onClick={() => { this.props.onChangeDateClick() }}
                value={this.props.changeDateAndButtonText + ' ' + this.props.filterDateAndTimeTitle}>
                {this.props.changeDateAndButtonText}
                <span className="visually-hidden"> {this.props.filterDateAndTimeTitle}</span>
            </button>
        }

        if (this.props.showComponent) {
            return (
                <section className="filters-section">
                    <div className="filters-section-heading contains-btn">
                        <h2 className="heading-general">{this.props.filterDateAndTimeTitle}</h2>
                        {button}
                    </div>
                    <p className="caption-paragraph">
                        {this.props.performanceDateString} | {this.props.performanceTimeString}
                    </p>
                </section>
            );
        } else {
            return null;
        }
    }
}

export default PerformanceInfo;